import SstBlock from '@features/ssts/components/SstBlock';
import { ColumnDef } from '@tanstack/react-table';
import { SstFront } from './type';

export const getSstColumns = (): ColumnDef<SstFront, unknown>[] => [
  {
    id: 'sst-block',
    cell: ({ row }) => <SstBlock key={row.original.id} {...row.original} />,
  },
];
